import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [/* @__PURE__ */ _jsx("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16z" }), /* @__PURE__ */ _jsx("path", { d: "M12.34 7.45a1.7 1.7 0 00-1.85-.3 1.6 1.6 0 00-1 1.48v6.74a1.6 1.6 0 001 1.48c.217.098.452.15.69.15a1.74 1.74 0 001.16-.45L16 13.18a1.6 1.6 0 000-2.36l-3.66-3.37zm-.84 7.15V9.4l2.81 2.6-2.81 2.6z" })]
		})
	})
});
export { SvgPlay as ReactComponent };
